import { Component, EventEmitter, inject, ChangeDetectionStrategy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ColorPickerComponent } from "../color-picker.component";

@Component({
    selector: "rask-color-picker-modal",
    templateUrl: "./color-picker-modal.component.html",
    styleUrls: ["./color-picker-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ColorPickerComponent]
})
export class ColorPickerModalComponent {
    readonly activeModal = inject(NgbActiveModal);

    colors: string[];
    color: string;
    model: EventEmitter<string> = new EventEmitter<string>();

    colorChanged($event) {
        this.color = $event;
        setTimeout(() => {
            this.activeModal.close(this.color);
        }, 500);
    }
}
